import { handleHttpError } from '@/utils/errorHandlers';
import { getArtistsService, type GetArtistActionsItemResponse } from '@art-basel/artbasel-lib-platform';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useArtistStore = defineStore(
  'useArtistStore',
  () => {
    const artistActionsList = ref<Record<string, GetArtistActionsItemResponse>>({});

    const fetchUserActionsForArtist = async (artistId: string | string[]) => {
      const artistIds = typeof artistId === 'string' ? [artistId] : artistId;

      if (!artistIds.length) {
        return;
      }

      try {
        const actions = await getArtistsService().getArtistActions(artistIds);

        actions.forEach((action: GetArtistActionsItemResponse) => {
          artistActionsList.value[action.id] = action;
        });
      } catch (error) {
        handleHttpError(error);
        return Promise.reject(error);
      }
    };

    const getUserActionsForArtist = async (artistId: string | string[]) => {
      const artistIds = typeof artistId === 'string' ? [artistId] : artistId;

      if (!artistIds.length) {
        return Array.isArray(artistId) ? {} : undefined;
      }

      const missingArtistIds = artistIds.filter((id) => !artistActionsList.value[id]);

      if (missingArtistIds.length) {
        await fetchUserActionsForArtist(missingArtistIds);
      }

      if (Array.isArray(artistId)) {
        return artistIds.reduce<Record<string, GetArtistActionsItemResponse | undefined>>((acc, id) => {
          acc[id] = artistActionsList.value[id];
          return acc;
        }, {});
      }

      return artistActionsList.value[artistIds[0]];
    };

    const reset = () => {
      artistActionsList.value = {};
    };

    return {
      getUserActionsForArtist,
      reset,
    };
  },
);
